import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Dumbbell, MoveRight } from 'lucide-react';
import { landingPages } from '../../data/landingPages';

const truncateWords = (text, max) => {
  if (text.length <= max) return text;
  const cut = text.lastIndexOf(' ', max);
  return text.slice(0, cut > 0 ? cut : max) + '…';
};

export const VerhuisServices = () => {
  return (
    <section className="py-14 bg-neutral-50" data-testid="verhuis-services">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-600 px-4 py-1.5 rounded-full text-sm font-bold mb-4">
            <Dumbbell className="w-4 h-4" />
            Verhuisdiensten
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-neutral-900 mb-3">
            Fitnessapparatuur verhuizen in heel Nederland
          </h2>
          <p className="text-neutral-600">
            Specialist in het veilig verhuizen, transporteren en (de)monteren van fitnessapparatuur. Bekijk onze verhuisdiensten.
          </p>
        </div>

        {/* Technogym afbeelding */}
        <div className="max-w-3xl mx-auto mb-10">
          <div className="relative rounded-3xl overflow-hidden bg-white border border-neutral-100 shadow-lg">
            <div className="absolute inset-0 m-auto w-2/3 h-2/3 bg-yellow-400/15 blur-3xl rounded-full" />
            <img
              src="/gym-interior.webp"
              alt="Moderne sportschool met fitnessapparatuur"
              className="relative w-full h-64 sm:h-80 object-cover"
              loading="lazy"
            />
            <span className="absolute bottom-4 left-4 inline-flex items-center gap-2 bg-yellow-400 text-black px-4 py-2 rounded-full text-sm font-bold shadow-lg">
              Specialist in Technogym verhuizen
            </span>
          </div>
        </div>

        {/* Before & After teaser */}
        <div className="max-w-3xl mx-auto mb-12 text-center" data-testid="before-after-teaser">
          <Link
            to="/voor-en-na"
            className="inline-flex items-center gap-2 bg-black text-yellow-400 hover:bg-neutral-800 px-6 py-3 rounded-full text-sm font-bold transition-colors"
            data-testid="voorna-link"
          >
            Bekijk onze Voor &amp; Na projecten <MoveRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {landingPages.map((page) => (
            <Link
              key={page.slug}
              to={`/diensten/${page.slug}`}
              data-testid={`verhuis-link-${page.slug}`}
              className="group bg-white rounded-2xl border border-neutral-100 shadow-sm hover:shadow-lg hover:border-yellow-200 transition-all p-6 flex items-center justify-between gap-4"
            >
              <div>
                <h3 className="font-bold text-neutral-900 group-hover:text-yellow-500 transition-colors">{page.h1}</h3>
                <p className="text-sm text-neutral-500 mt-1 line-clamp-2">{truncateWords(page.intro[0], 90)}</p>
              </div>
              <div className="w-10 h-10 bg-neutral-100 group-hover:bg-yellow-400 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors">
                <ArrowRight className="w-5 h-5 text-neutral-500 group-hover:text-black transition-colors" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VerhuisServices;
